// IE11 兼容：全量 polyfill（node_modules 内部用到的 ES6+ API 不在 usage 自动注入范围内）
import 'core-js/stable';
import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
